module.exports = __webpack_public_path__ + "static/media/energy.3e880871.png";